import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]
  static classes = ["active", "inactive"]

  connect() {
    const firstButton = this.buttonTargets[0]
    if (firstButton) {
      const panelId = firstButton.dataset.tabsPanelId
      if (panelId) {
        this.showPanel(panelId)
      }
    }
  }

  switch(event) {
    event.preventDefault()
    const panelId = event.currentTarget.dataset.tabsPanelId
    if (panelId) {
      this.showPanel(panelId)
    }
  }

  showPanel(panelId) {
    if (!panelId) return

    this.buttonTargets.forEach(button => {
      const isActive = button.dataset.tabsPanelId === panelId
      button.classList.add(...(isActive ? this.activeClasses : this.inactiveClasses))
      button.classList.remove(...(isActive ? this.inactiveClasses : this.activeClasses))
    })

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tabsPanelId !== panelId)
    })
  }
}
